import { usePreviousNumberAnswers } from '@app/src/context/PreviousNumberAnswersContext'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { DeviationIndicator } from '../../DeviationIndicator'

interface NumberDisplayWithDeviationProps {
  answer: string | number
  unitSymbol: string | null | undefined
  questionId: number
}

export const NumberDisplayWithDeviation: React.FC<NumberDisplayWithDeviationProps> = ({
  answer,
  unitSymbol,
  questionId,
}) => {
  const { previousNumberAnswers } = usePreviousNumberAnswers()

  const answerToThisQuestion = previousNumberAnswers.filter(p => p.requestItem.questionId === questionId)

  return (
    <Stack direction="row" width="100%">
      <Typography width="100%">
        {answer ?? ''} {unitSymbol ?? ''}
      </Typography>
      <DeviationIndicator selectedValue={answer} unitSymbol={unitSymbol} answersToThisQuestion={answerToThisQuestion} />
    </Stack>
  )
}
